module.exports = __webpack_public_path__ + "media/is there any hope Mix SF 4.723cea20.mp3";